module.exports = __webpack_public_path__ + "2573a548cf55d7e9b386ed81fe8d0615.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2000_43_teaser_image.jpg
// module id = 549
// module chunks = 0